import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData,
  type DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteError,
  type DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponse,
  deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDelete,
} from '../../generated';

export type DeleteOrganizationIcpProductCategoryMutationVariables =
  DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData['path'];

export type DeleteOrganizationIcpProductCategoryMutation =
  DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponse;

export const useDeleteOrganizationIcpProductCategoryMutation = <
  TError = DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      DeleteOrganizationIcpProductCategoryMutation,
      TError,
      DeleteOrganizationIcpProductCategoryMutationVariables,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<
    DeleteOrganizationIcpProductCategoryMutation,
    TError,
    DeleteOrganizationIcpProductCategoryMutationVariables,
    TContext
  >({
    mutationKey: ['DeleteOrganizationIcpProductCategory'],
    mutationFn: async ({ org_id, icp_product_category_id }: DeleteOrganizationIcpProductCategoryMutationVariables) => {
      const { data } =
        await deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDelete({
          path: { org_id, icp_product_category_id },
          throwOnError: true,
        });
      return data;
    },
    ...options,
  });
};

useDeleteOrganizationIcpProductCategoryMutation.fetcher = (
  { org_id, icp_product_category_id }: DeleteOrganizationIcpProductCategoryMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } =
      await deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDelete({
        path: { org_id, icp_product_category_id },
        throwOnError: true,
      });
    return data;
  };
};
